import { html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import componentStyle from '../common/styles/Component.css'
import style from './Footer.css'

/**
 * The footer is a block of designated space for providing additional information or actions that are positioned below the main content.
 *
 * @status new
 * @category structure
 * @slot - The footer content.
 *
 * @cssprop [--n-footer-padding-inline=var(--n-space-l)] - Controls the inline padding around the footer’s main slot, using [spacing tokens](/tokens/#space).
 * @cssprop [--n-footer-box-shadow=var(--n-box-shadow-header)] - Controls the box shadow of the footer, using [box shadow tokens](/tokens/#box-shadow).
 * @cssprop [--n-footer-background-color=var(--n-color-surface)] - Controls the background color of the footer, using [color tokens](/tokens/#color).
 */
@customElement('nord-footer')
export default class Footer extends LitElement {
  static styles = [componentStyle, style]

  /**
   * Controls the size of the footer component.
   */
  @property({ reflect: true }) size: 'm' | 's' = 'm'

  render() {
    return html`
      <footer class="n-footer">
        <slot></slot>
      </footer>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-footer': Footer
  }
}
